"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSubset = isSubset;
exports.sortedUrl = sortedUrl;
exports.toSortedQueryString = toSortedQueryString;

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function toSortedQueryString(entry) {
  if (!(0, _utils.isPlainObject)(entry)) {
    return entry;
  }

  return (0, _utils.validKeys)(entry).sort().map(function (key) {
    var value = entry[key];

    if ((0, _utils.isPlainObject)(value)) {
      return toSortedQueryString(value);
    }

    return (0, _utils.buildRecursive)(key, value);
  }).join('&').replace(/%20/g, '+');
}
/**
 * Filters an `object` by keeping only the keys fulfilling the `predicate`
 *
 * @param {Object} object - An object
 * @param {Function} predicate - A function of type (key: string) => boolean
 * @returns {Object} The filtered object
 */


function filterByPredicate(object, predicate) {
  return Object.entries(object).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return predicate(key);
  }).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
  }, {});
}
/**
 * Verify if the object `A` is contained within object `B` - shallowly.
 * In other words, is A a subset of B?
 *
 * @see https://en.wikipedia.org/wiki/Subset
 *
 * @param {Object} A - The object to test
 * @param {Object} B - The superset object to verify against
 * @returns A boolean representing if A is a shallow subset of B
 */


function isSubset(A, B) {
  // Make B only contain the non-nullish keys it has in in common with A
  var keysFromA = (0, _utils.validKeys)(A);
  var filteredB = filterByPredicate(B, function (keyFromB) {
    return keysFromA.includes(keyFromB);
  });
  return toSortedQueryString(A) === toSortedQueryString(filteredB);
}
/**
 * Sort the query params on a URL based on the 'key=value' string value.
 * E.g. /example?b=2&a=1 will become /example?a=1&b=2
 *
 * @param {String} url - a URL that should be sorted (with or without query params)
 */


function sortedUrl(url) {
  var urlParts = url.split('?');

  if (urlParts.length > 1) {
    var query = urlParts[1];
    var sortedQuery = query.split('&').sort().join('&');
    return "".concat(urlParts[0], "?").concat(sortedQuery);
  } else {
    return urlParts[0];
  }
}